import { IApplePaySettings } from '../types/applePay';

export const defaultApplePaySettings: IApplePaySettings = {
  enabled: false,
  displayName: '',
  domains: [],
};
